import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { translate } from 'react-i18next'
import { connect } from 'react-redux'
import classNames from 'classnames'
import Select from '../Select/Select'
import * as parameterActions from 'action/systemParameters'
import Api from 'utils/ApiRequest'
import { bindActionCreators } from 'redux'
import API_URL from 'constants/api'

const ALL = 'all'

class RegionBranchMultipleSelect extends Component {
  static propTypes = {
    name: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    showInternalServices: PropTypes.bool,
    translate: PropTypes.func.isRequired,
    user: PropTypes.object,
    value: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),
    allOption: PropTypes.bool,
    className: PropTypes.string,
    userBranch: PropTypes.string,
    required: PropTypes.bool,
    paramsSupply: PropTypes.bool,
    disabled: PropTypes.bool,
    analyticsDetails: PropTypes.bool,
    setPrevValues: PropTypes.func,
    getAllBranchs: PropTypes.func,
    getParameterString: PropTypes.func,
    errorText: PropTypes.string,
    disableLoading: PropTypes.bool,
    excludeInactive: PropTypes.bool,
  }

  state = {
    options: [],
    error: null,
    loading: false,
    missionsSelectBranchs: []
  }

  getParameter(values) {
    const {user} = this.props
    return new Api(user.dsToken)
    .get(API_URL.PARAMETER_GET, values)
    .then(resp => this.setState({missionsSelectBranchs: resp.data.split(",")}))
  }

  componentDidMount() {
    const params = {
      dsKey: "missions.select.branchs",
      nuParameter: 1
    }

    // If disableLoading is true and we have values, don't show loading
    if (this.props.disableLoading && this.props.value && this.props.value.length > 0) {
      this.setState({ loading: false });
    }

    this.getParameter(params).finally(() => this.fetchData().then(() => {
      if(this.props.getAllBranchs) {

          this.props.getAllBranchs(this.state.options)
      }
      if(this.props.analyticsDetails) {
        this.handleChange(this.state.options)
        if(this.props.setPrevValues) this.props.setPrevValues(this.state.options)
      }
    }))

  }

  fetchData = async () => {
    const { user, disableLoading, value, excludeInactive } = this.props

    if (user) {
      // Only show loading if we don't have disableLoading or values
      if (!disableLoading || !value || value.length === 0) {
        this.setState({ loading: true })
      }

      try {
        const endpoint = excludeInactive ? `${API_URL.BRANCHES}?excludeInactive=true` : API_URL.BRANCHES
        const { data } = await new Api(user.dsToken).post(endpoint)

        this.onFetchSuccess(data)
      } catch (error) {
        this.onFetchError(error)
      }
    }
  }

  onFetchSuccess = (companies) => {
    const { showInternalServices, translate, value, allOption, userBranch } =
      this.props

    // Remover duplicatas de companies baseado no id
    const uniqueCompanies = companies.filter((company, index, self) =>
      index === self.findIndex((c) => c.id === company.id)
    )

    const regionCompanies = uniqueCompanies.reduce((regionObj, company) => {
      const { idRegion } = company

      if (!regionObj[idRegion]) {
        const { dsRegion } = company

        regionObj[idRegion] = {
          branches: [],
          idRegion,
          dsRegion,
        }
      }

      regionObj[idRegion].branches.push(company)

      return regionObj
    }, {})

    const orderedRegionsIds = Object.keys(regionCompanies).sort(
      (idRegionA, idRegionB) => {
        const regionA = regionCompanies[idRegionA]
        const regionB = regionCompanies[idRegionB]

        if (regionA.dsRegion < regionB.dsRegion) return -1
        if (regionA.dsRegion > regionB.dsRegion) return 1
        return 0
      }
    )

    const newValue = [...value]

    const companyOptions = orderedRegionsIds.reduce((options, id) => {
      const { idRegion, dsRegion, branches } = regionCompanies[id]

      const isRegionSelected = newValue.some(
        (selected) => selected.value === idRegion
      )

      options.push({
        value: idRegion,
        label: dsRegion,
        visible: !isRegionSelected,
        disabled: isRegionSelected,
        idBranches: companies.reduce((acc, cur) => {
          if (cur.idRegion === idRegion) {
            return [...acc, cur.id]
          }

          return acc
        }, []),
      })

      branches.forEach((branch) => {
        const matchIndex = newValue.findIndex(
          (selected) => selected.value === branch.id
        )

        // Ensures that each branch populates with idRegion
        if (matchIndex > -1) {
          newValue[matchIndex] = {
            ...value[matchIndex],
            idRegion: branch.idRegion,
          }
        }

        options.push({
          value: branch.id,
          label: `${branch.id} - ${branch.name}`,
          isBranch: true,
          idRegion: branch.idRegion,
          visible: !isRegionSelected,
          disabled: isRegionSelected,
        })
      })

      return options
    }, [])


    if (showInternalServices) {
      companyOptions.push({
        value: 999,
        label: `0999 - ${translate('analytics.matrix.name')}`,
        isBranch: true,
        isBold: true,
        visible: true,
      })
    }

    if (allOption) {
      companyOptions.unshift({
        value: ALL,
        label: translate('option.all'),
        visible: true,
      })
    }


    this.setState({ options: companyOptions, loading: false, error: null })
    // Update values with the udpated ones
    if (newValue && newValue.length > 0) {
      this.handleChange(newValue)
    }

    const hasBranchSelectPermission = this.state.missionsSelectBranchs.includes(this.props.user.title)

    if (userBranch !== undefined && userBranch !== '999') {
      if(!hasBranchSelectPermission) {

        const determinedBranch = companyOptions.filter(
          (option) => option.value === userBranch.padStart(4, '0')
        )

        this.handleChange(determinedBranch)
      }
    }
  }

  onFetchError = (error) => {
    this.setState({ error, loading: false, options: [] })
  }

  handleChange = (value) => {
    const { onChange, name } = this.props

    const { options } = this.state

    let event = { target: { name, value } }

    if (value.some((option) => option.value === ALL)) {
      const newValue = options.filter(
        (option) => option.isBranch || option.value === ALL
      )
      event = { target: { name, value: newValue } }
    }

    const totalBranches = options.filter((o) => o.isBranch).length
    const selectedBranches = (event.target.value || []).filter((o) => o.isBranch)
      .length
    const inAllBranchs = totalBranches > 0 && selectedBranches >= totalBranches

    if (inAllBranchs) {
      event.target.value = (event.target.value || []).filter((o) => o.isBranch)
    }

    event.target.inAllBranchs = inAllBranchs

    if (onChange) {
      onChange(event)
    }
  }

  filterOptions = (option, inputValue) => {
    inputValue = inputValue.toLowerCase()
    const lcLabel = option.label.toLowerCase()

    const matches = lcLabel.includes(inputValue)

    return matches && option.data.visible
  }

  renderOption = (option) => {
    const isBranchAndNotBold = option.isBranch && !option.isBold

    const className = classNames(
      { 'option-branch': isBranchAndNotBold },
      { 'option-region': !isBranchAndNotBold },
      { hidden: !option.visible }
    )

    return (
      <option value={option.value} className={className}>
        {option.label}
      </option>
    )
  }

  checkValues() {
    const { value, disableLoading } = this.props
    const { options } = this.state

    // If disableLoading is true and we have values, return values directly
    if (disableLoading && value && value.length > 0) {
      return value;
    }

    return options.filter((o) =>
      (value || []).find(
        (v) => v.value && o.value && o.value.toString() === v.value.toString()
      )
    )
  }

  render() {
    const { label, value, required, translate, placeholder, paramsSupply, disabled, errorText, disableLoading } = this.props
    const { options, loading } = this.state

    // If disableLoading is true, always show the original placeholder
    const placeholderLabel = disableLoading ? placeholder : (loading ? translate('loading') : placeholder)

    const newValue = value ? this.checkValues() : value

    return (
      <Select
        fill
        isMulti
        groupOptions
        label={label}
        placeholder={placeholderLabel}
        value={newValue}
        options={options}
        onChange={this.handleChange}
        selectAll
        required={required}
        validateValue={(val) => val && val.length > 0}
        paramsSupply={paramsSupply}
        disabled={disabled && ( !this.state.missionsSelectBranchs.includes(this.props.user.title) ) ||  !(this.props.userBranch === "999" || this.props.userBranch === undefined) }
        errorText={errorText}
      />
    )
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ ...parameterActions }, dispatch)

const mapStateToProps = ({ auth }) => ({
  user: auth.user,
})

/*
 * Connects component to I18next
 */
const RegionBranchMultipleSelectTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(RegionBranchMultipleSelect)

/*
 * Exports component connected to redux
 */
export default connect(mapStateToProps, mapDispatchToProps)(RegionBranchMultipleSelectTranslated)

/*
 * Exports component only
 */
export { RegionBranchMultipleSelect }
